import BasicLayout from '@/layouts/Basic';
import {wrapModelLoaderAsBeforeRouterEnterHook} from '../lib/model';

const importEnv = require('./_import_' + process.env.NODE_ENV);

export default [
    {
        path: '/user/:userid/imageCreate',
        name: 'imageCreateWork',
        component: BasicLayout,
        meta: {
            onlyV1: true
        },
        children: [
            {
                path: '/',
                redirect: {
                    name: 'imageCreateWork'
                }
            },
            {
                path: 'old_work',
                name: 'oldImageCreateWork',
                meta: {
                    authorizedRole: 'digital_education_image',
                    show404: true
                },
                component: importEnv('ImageCreate/work/index')
            },
            {
                path: 'work',
                name: 'imageCreateWork',
                meta: {
                    authorizedRole: 'digital_education_image',
                    show404: true
                },
                component: importEnv('Image/work/index'),
                redirect: {
                    name: 'imageCreateWorkFront'
                },
                children: [
                    {
                        path: 'front',
                        name: 'imageCreateWorkFront',
                        meta: {
                            authorizedRole: 'digital_education_image',
                            show404: true
                        },
                        component: importEnv('Image/work/frontPage'),
                        beforeEnter: wrapModelLoaderAsBeforeRouterEnterHook('myCreation', () =>
                            import('../model/myCreation')
                        )
                    },
                    {
                        path: 'template',
                        name: 'imageCreateWorkTemplate',
                        meta: {
                            authorizedRole: 'digital_education_image',
                            show404: true
                        },
                        component: importEnv('Image/template/index')
                    },
                    {
                        path: 'material',
                        name: 'imageCreateWorkMaterial',
                        meta: {
                            authorizedRole: 'digital_education_image',
                            show404: true
                        },
                        component: importEnv('Image/material/index'),
                        beforeEnter: wrapModelLoaderAsBeforeRouterEnterHook('myCreation', () =>
                            import('../model/myCreation')
                        )
                    },
                    {
                        path: 'marketingNew',
                        name: 'marketImageCreateNew',
                        meta: {
                            authorizedRole: 'digital_education_image',
                            show404: true,
                            source: 'poster'
                        },
                        beforeEnter: wrapModelLoaderAsBeforeRouterEnterHook([
                            {name: 'ImageCreate', loader: () => import('../model/ImageCreate')},
                            {name: 'specialCreate', loader: () => import('../model/specialCreate')},
                            {name: 'myCreation', loader: () => import('../model/myCreation')}
                        ]),
                        component: importEnv('Image/market/index')
                    },
                    {
                        path: 'marketing',
                        name: 'marketImageCreate',
                        meta: {
                            authorizedRole: 'digital_education_image',
                            show404: true,
                            source: 'poster'
                        },
                        beforeEnter: wrapModelLoaderAsBeforeRouterEnterHook([
                            {name: 'ImageCreate', loader: () => import('../model/ImageCreate')},
                            {name: 'specialCreate', loader: () => import('../model/specialCreate')}
                        ]),
                        component: importEnv('Image/marketOld/index')
                    },
                    {
                        path: 'smartcutout',
                        name: 'smartCutImage',
                        meta: {
                            authorizedRole: 'digital_education_image',
                            show404: true
                        },
                        beforeEnter: wrapModelLoaderAsBeforeRouterEnterHook([
                            {name: 'ImageCreate', loader: () => import('../model/ImageCreate')}
                        ]),
                        component: importEnv('Image/cutout/index')
                    },
                    {
                        path: 'aiexpandimg',
                        name: 'aiExpandImage',
                        meta: {
                            authorizedRole: 'digital_education_image',
                            show404: true
                        },
                        beforeEnter: wrapModelLoaderAsBeforeRouterEnterHook([
                            {name: 'ImageCreate', loader: () => import('../model/ImageCreate')}
                        ]),
                        component: importEnv('Image/expand/index')
                    },
                    {
                        path: 'imagestitching',
                        name: 'imageStitching',
                        meta: {
                            authorizedRole: 'digital_education_image',
                            show404: true
                        },
                        beforeEnter: wrapModelLoaderAsBeforeRouterEnterHook([
                            {name: 'ImageCreate', loader: () => import('../model/ImageCreate')}
                        ]),
                        component: importEnv('Image/stitching/index')
                    },
                    {
                        path: 'smartcropimg',
                        name: 'smartCropImg',
                        meta: {
                            authorizedRole: 'digital_education_image',
                            show404: true
                        },
                        beforeEnter: wrapModelLoaderAsBeforeRouterEnterHook([
                            {name: 'ImageCreate', loader: () => import('../model/ImageCreate')}
                        ]),
                        component: importEnv('Image/crop/index')
                    }
                ]
            },
            {
                path: 'fromText',
                name: 'imageCreateFromText',
                meta: {
                    authorizedRole: 'digital_education_image',
                    show404: true,
                    source: 'text'
                },
                beforeEnter: wrapModelLoaderAsBeforeRouterEnterHook([
                    {name: 'ImageCreate', loader: () => import('../model/ImageCreate')},
                    {name: 'specialCreate', loader: () => import('../model/specialCreate')}
                ]),
                component: importEnv('ImageCreate/create/AiContent')
            },
            {
                path: 'fromPoster',
                name: 'imageCreateFromPoster',
                meta: {
                    authorizedRole: 'digital_education_image',
                    show404: true,
                    source: 'poster'
                },
                beforeEnter: wrapModelLoaderAsBeforeRouterEnterHook([
                    {name: 'ImageCreate', loader: () => import('../model/ImageCreate')},
                    {name: 'specialCreate', loader: () => import('../model/specialCreate')}
                ]),
                component: importEnv('ImageCreate/create/AiContent')
            },
            {
                path: 'fromImage',
                name: 'imageCreateFromImage',
                meta: {
                    authorizedRole: 'digital_education_image',
                    show404: true,
                    source: 'image'
                },
                beforeEnter: wrapModelLoaderAsBeforeRouterEnterHook([
                    {name: 'ImageCreate', loader: () => import('../model/ImageCreate')},
                    {name: 'specialCreate', loader: () => import('../model/specialCreate')}
                ]),
                component: importEnv('ImageCreate/create/AiContent')
            }
        ]
    }
];
